import { TThreeUtpBlock } from 'shared/types/utp';

export const UTP: TThreeUtpBlock = [
  {
    color: 'gray',
    title: 'Разовое размещение',
    description: 'Частным владельцам и специалистам, которые публикуют объявления нерегулярно',
  },
  {
    color: 'light-blue',
    title: 'Пакеты',
    description: 'Для тех, кто размещает до 20 объектов в месяц и хочет сократить расходы на продвижение',
  },
  {
    color: 'blue',
    title: 'Подписки',
    description: 'Для агентств с более чем 20 объектами, которым интересен кешбэк, брендирование и максимальная выгода',
  },
];
